const activities = [
  {
    name: 'editGoalDetails.normalGoal',
    value: 'editGoalDetails.normalGoal',
  },
  {
    name: 'createGoalCreationRecommendationWizard',
    value: 'createGoalCreationRecommendationWizard',
  },
];

export const instrumentationSchema = {
  scenario: [
    {
      name: 'goalCreationRecommendationWizard',
      value: 'goalCreationRecommendationWizard',
      activity: activities,
    },
  ],
};
